import { fromJS } from 'immutable';

import {
  GET_AGENTS,
  SET_AGENTS,
  GET_AGENTS_FAILED,
  GET_CITIES,
  GET_CITIES_FAILED,
  GET_CITIES_SUCCESS,
} from 'store/geolocAgent/constants';
import { geolocAgentActionType } from 'store/geolocAgent/actions';

export const initialState = fromJS({
  isLoadingAgent: false,
  AgentsInfo: null,
  errorMessageGetAgent: null,
  cities: [],
  isLoadingCities: false,
  errorMessageGetCities: '',
});
export default function reducer(
  state = initialState,
  action: geolocAgentActionType,
) {
  switch (action.type) {
    case GET_AGENTS:
      return state.set('isLoadingAgent', true);
    case SET_AGENTS:
      return state
        .set('AgentsInfo', action.payload)
        .set('isLoadingAgent', false)
        .set('errorMessageGetAgent', null);
    case GET_AGENTS_FAILED:
      return state.set('errorMessageGetAgent', action.payload);
    case GET_CITIES:
      return state.set('isLoadingCities', true);
    case GET_CITIES_SUCCESS:
      return state.set('cities', action.payload).set('isLoadingCities', false);
    case GET_CITIES_FAILED:
      return state
        .set('errorMessageGetCities', action.payload)
        .set('isLoadingCities', false);
    default:
      return state;
  }
}
